import styled from "@emotion/styled";
import { CopyIcon } from "./CopyIcon";
import { FadeInContent } from "./FadeInContent";
import { Italic } from "./Italic";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #eaeaea;
  padding-top: 20px;
  gap: 10px;
  width: 100%;
  padding-bottom: 20px;
  padding-left: 10px;
  padding-right: 10px;
`;

const MoneyWrapper = styled.div`
  width: 100%;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  border: 1px solid #eaeaea;
  border-radius: 5px;
  position: relative;
  padding-top: 30px;
  margin-bottom: 20px;
`;

const MoneyWrapperLabel = styled.div`
  position: absolute;
  top: -10px;
  left: 10px;
  background-color: white;
  padding: 5px;
  font-size: 12px;
  color: #999;
  border-radius: 5px;
  border: 1px solid #eaeaea;
  font-weight: bold;
`;

const BankNumber = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;

const NameDesc = styled.span`
  font-size: 12px;
  color: #999;
`;

export function Money() {
  return (
    <Container>
      <FadeInContent
        style={{
          marginBottom: "20px",
        }}
      >
        <Italic>- for your heart -</Italic>
      </FadeInContent>
      {/* <FadeInContent>
        <b>마음 전하실 곳</b>
      </FadeInContent> */}
      <FadeInContent
        style={{
          width: "100%",
        }}
      >
        <MoneyWrapper>
          <MoneyWrapperLabel>신랑측</MoneyWrapperLabel>
          <div>
            <NameDesc>아버지</NameDesc> 차준경
          </div>
          <div>
            농협 302-8823-0691-81 <CopyIcon text="302-8823-0691-81" />
          </div>
           <div>
            <NameDesc>어머니</NameDesc> 안연희
          </div>
          <div>
            농협 470-02-062278 <CopyIcon text="470-02-062278" />
          </div>
          <div>
            <NameDesc>신랑</NameDesc> 차이새
          </div>
          <div style={{ display: "flex" }}>
            <BankNumber>
              우리은행 1002-643-623994 <CopyIcon text="1002-643-623994" />
            </BankNumber>
          </div>
        </MoneyWrapper>
      </FadeInContent>

      <FadeInContent
        style={{
          width: "100%",
        }}
      >
        <MoneyWrapper>
          <MoneyWrapperLabel>신부측</MoneyWrapperLabel>
          <div>
            <NameDesc>아버지</NameDesc> 김성우
          </div>
          <div>
            기업은행 031-060941-01-015 <CopyIcon text="031-060941-01-015" />
          </div>
          <div>
            <NameDesc>어머니</NameDesc> 이은경
          </div>
          <div>
            기업은행 031-060875-02-022 <CopyIcon text="031-060875-02-022" />
          </div>
          <div>
            <NameDesc>신부</NameDesc> 김민지
          </div>
          <div style={{ display: "flex" }}>
            <div>
              우리은행 1002-348-123267 <CopyIcon text="1002-348-123267" />
            </div>
          </div>
        </MoneyWrapper>
      </FadeInContent>
    </Container>
  );
}
